// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__8KDU9","colMaxWidth":"Table_colMaxWidth__cyx-n"};